import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService
} from '@fpx/core';
import { IHttpSuccessPayload, ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of } from 'rxjs';
import { Verifyotp, VerifyotpMaintanence } from './verifyotp.model';
import { environment } from 'src/environments/environment';
@Injectable()
export class VerifyotpService implements BaseFpxDataService<any> {
  constructor(private _httpProvider: HttpProviderService) { }
  findAll(criteriaQuery: CriteriaQuery): FindAllFn<any> {
    throw new Error('Method not implemented.');
  }
  lookup(key: unknown): LookUpFn<any> {
    throw new Error('Method not implemented.');
  }
  create(payload: Verifyotp): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/verifyotp');
      let bodyContent = { "verifyotp": payload };
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }

  findByKey(key: Verifyotp): FindByKeyFn<Verifyotp> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/verifyotp/{processCode}/{stageCode}');
      httpRequest.addPathParameter('processCode', key.processCode);
      httpRequest.addPathParameter('stageCode', key.stageCode);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.verifyotp ?? null));

    };
  }

  modify(payload: Verifyotp): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/verifyotp/{processCode}/{stageCode}');
      httpRequest.addPathParameter('processCode', payload.processCode);
      httpRequest.addPathParameter('stageCode', payload.stageCode);
      httpRequest.setMethod('PUT');
      let bodyContent = { "verifyotp": payload };
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }
  resendOTP(payload): Observable<any> {
    const httpRequest = new HttpRequest();
    httpRequest.setServerContext(environment.customersPublisher);
    httpRequest.setMethod('POST');
    httpRequest.setResource('/resendotp');
    let bodyContent = { "resendotp": payload };
    httpRequest.setBody(bodyContent);
    return this._httpProvider.invokeRestApi(httpRequest);
   };


}
